"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuid = require("uuid/v4");
var WAIT_TIMEOUT = 5000;
exports.emitMessage = function (_a) {
    var type = _a.type, _b = _a.payload, payload = _b === void 0 ? {} : _b, _c = _a.scope, scope = _c === void 0 ? window : _c, origin = _a.origin;
    var eventId = type + "-" + uuid();
    var waitId = null;
    var request = { type: type, payload: payload, eventId: eventId };
    return (new Promise(function (resolve, reject) {
        var replyCallback = function (event) {
            if (event.data.eventId === eventId) {
                clearTimeout(waitId);
                if (event.data.error) {
                    reject(event.data.error);
                }
                else {
                    resolve(event.data.payload);
                }
                if (window.removeEventListener) {
                    window.removeEventListener('message', replyCallback);
                }
            }
        };
        waitId = setTimeout(function () {
            if (window.removeEventListener) {
                window.removeEventListener('message', replyCallback);
            }
            reject({ errorCode: 502 });
        }, WAIT_TIMEOUT);
        window.addEventListener('message', replyCallback);
        if (scope.postMessage) {
            scope.postMessage(request, origin || '*');
        }
    }));
};
//# sourceMappingURL=postMessagesPubSub.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/utils/postMessagesPubSub.js
// module id = 392
// module chunks = 0 1